import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';

const Contact = () => {
  const containerVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        when: 'beforeChildren',
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 1, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const buttonVariants = {
    hover: { scale: 1.1, backgroundColor: '#4d760c', borderColor: '#4d760c' },
  };

  return (
    <motion.div
      className='w-full h-screen bg-[#080808] flex flex-col justify-center items-center p-4 min-h-[100vh]'
      initial='hidden'
      animate='visible'
      variants={containerVariants}
    >
      {/* Section Title */}
      <motion.div className='pb-8 w-full' variants={itemVariants}>
        <div className='flex items-center px-[2%]'>
          <motion.div
            className='w-full h-[1px] bg-[#353535]'
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.5 }}
          ></motion.div>
          <motion.p
            className='text-4xl text-center font-bold mx-3 text-[#4d760c]'
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            contact
          </motion.p>
          <motion.div
            className='w-full h-[1px] bg-[#353535]'
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.5 }}
          ></motion.div>
        </div>
      </motion.div>

      {/* Form */}
      <motion.form
        method='POST'
        action='https://getform.io/f/5362267e-6e6f-4c2f-85f1-785ada893c1e'
        className='flex flex-col max-w-[600px] w-full px-[5%]'
        variants={containerVariants}
      >
        <motion.input
          className='bg-[#ccd6f6] p-2'
          placeholder='Name'
          name='name'
          type='text'
          variants={itemVariants}
        />
        <motion.input
          className='my-4 p-2 bg-[#ccd6f6]'
          type='email'
          name='email'
          placeholder='Email'
          variants={itemVariants}
        />
        <motion.textarea
          name='message'
          rows='10'
          placeholder='Message'
          className='bg-[#ccd6f6]'
          variants={itemVariants}
        ></motion.textarea>
        <motion.button
          className='text-white border-2 hover:bg-[#4d760c] hover:border-[#4d760c] px-4 py-3 my-8 mx-auto flex items-center'
          variants={buttonVariants}
          whileHover='hover'
        >
          Let's Collaborate
        </motion.button>
      </motion.form>

      {/* Social Icons */}
      <motion.ul
        className='flex text-gray-300 mt-8'
        variants={containerVariants}
      >
        {[
          {
            href: 'https://www.linkedin.com/in/ayoashy/',
            icon: FaLinkedin,
            bg: '#0078b2',
          },
          { href: 'https://github.com/ayoashy', icon: FaGithub, bg: '#1b1d21' },
          {
            href: 'mailto:ashiruayo@gmail.com',
            icon: HiOutlineMail,
            bg: '#ce463e',
          },
          {
            href: 'https://twitter.com/topboyshoks',
            icon: FaTwitter,
            bg: 'blue-600',
          },
        ].map(({ href, icon: Icon, bg }, index) => (
          <motion.li
            key={index}
            className={`p-4 bg-[${bg}] bg-${bg}`}
            variants={itemVariants}
            whileHover={{ scale: 1.1 }}
          >
            <a href={href} target='_blank' rel='noopener noreferrer'>
              <Icon size={30} />
            </a>
          </motion.li>
        ))}
      </motion.ul>
    </motion.div>
  );
};

export default Contact;
